import { AssetItem, RecommendedAsset } from 'config/api/actionLibrary/actionLibrary.types';

/**
 * Filters recommended assets by search term and importance
 */
export const filterRecommendedAssets = (assets: RecommendedAsset[], search: string, importance?: string): RecommendedAsset[] => {
  if (!assets || !Array.isArray(assets)) {
    return [];
  }

  let filtered = assets;

  if (importance && importance !== 'all') {
    filtered = filtered.filter(asset => asset.importance === importance);
  }

  if (!search) return filtered;

  const searchLower = search.toLowerCase();
  return filtered.filter(
    asset =>
      asset?.name?.toLowerCase().includes(searchLower) ||
      asset?.owner?.profile?.firstName?.toLowerCase().includes(searchLower) ||
      asset?.owner?.profile?.lastName?.toLowerCase().includes(searchLower) ||
      asset?.owner?.email?.toLowerCase().includes(searchLower) ||
      asset?.category?.name?.toLowerCase().includes(searchLower) ||
      asset?.type?.toLowerCase().includes(searchLower),
  );
};

/**
 * Filters available assets by search term, excludes recommended ones, and filters by importance
 */
export const filterAvailableAssets = (
  availableAssets: AssetItem[],
  recommendedAssets: RecommendedAsset[],
  search: string,
  importance?: string,
): AssetItem[] => {
  if (!availableAssets) return [];

  const recommendedIds = new Set(recommendedAssets.map(a => a.id));
  let filtered = availableAssets.filter(asset => !recommendedIds.has(asset.id));

  if (importance && importance !== 'all') {
    filtered = filtered.filter(asset => asset.importance === importance);
  }

  if (search) {
    const searchLower = search.toLowerCase();
    filtered = filtered.filter(
      asset =>
        asset.name.toLowerCase().includes(searchLower) ||
        asset.owner.fullName.toLowerCase().includes(searchLower) ||
        asset.owner.email.toLowerCase().includes(searchLower) ||
        (asset.category && asset.category.name.toLowerCase().includes(searchLower)),
    );
  }

  return filtered;
};
